import _ from "underscore";

const ATTRS = [
  {
    id: "new-1",
    attrNo: 1,
    order: 2,
    presetFlg: true,
    locale: {
      ja: {
        attrName: "性別",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "男" },
          { id: "2", itemNo: 2, order: 2, itemName: "女" }
        ]
      },
      en: {
        attrName: "sex",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "Man" },
          { id: "2", itemNo: 2, order: 2, itemName: "Woman" }
        ]
      },
      zh: {
        attrName: "性别",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "一个男人" },
          { id: "2", itemNo: 2, order: 2, itemName: "女子" }
        ]
      },
      vi: {
        attrName: "Giới tính",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "Một người đàn ông" },
          { id: "2", itemNo: 2, order: 2, itemName: "F" }
        ]
      }
    }
  },
  {
    id: "new-2",
    attrNo: 2,
    order: 1,
    presetFlg: true,
    dept_flg: true,
    locale: {
      ja: {
        attrName: "部門",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "営業" },
          { id: "2", itemNo: 2, order: 2, itemName: "総務" },
          { id: "3", itemNo: 3, order: 3, itemName: "経理" },
          { id: "4", itemNo: 4, order: 4, itemName: "システム" }
        ]
      },
      en: {
        attrName: "Department",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "Sales" },
          { id: "2", itemNo: 2, order: 2, itemName: "General affairs" },
          { id: "3", itemNo: 3, order: 3, itemName: "Accounting" },
          { id: "4", itemNo: 4, order: 4, itemName: "System" }
        ]
      },
      zh: {
        attrName: "部门",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "业务" },
          { id: "2", itemNo: 2, order: 2, itemName: "总务" },
          { id: "3", itemNo: 3, order: 3, itemName: "会计" },
          { id: "4", itemNo: 4, order: 4, itemName: "系统" }
        ]
      },
      vi: {
        attrName: "Bộ phận",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "Bán hàng" },
          { id: "2", itemNo: 2, order: 2, itemName: "Các vấn đề chung" },
          { id: "3", itemNo: 3, order: 3, itemName: "Kế toán" },
          { id: "4", itemNo: 4, order: 4, itemName: "Hệ thống" }
        ]
      }
    }
  },
  {
    id: "new-3",
    attrNo: 3,
    order: 3,
    presetFlg: true,
    locale: {
      ja: {
        attrName: "年齢",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "10代" },
          { id: "2", itemNo: 2, order: 2, itemName: "20代" },
          { id: "3", itemNo: 3, order: 3, itemName: "30代" },
          { id: "4", itemNo: 4, order: 4, itemName: "40代" },
          { id: "5", itemNo: 5, order: 5, itemName: "50代" },
          { id: "6", itemNo: 6, order: 6, itemName: "60代以上" }
        ]
      },
      en: {
        attrName: "age",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "10's" },
          { id: "2", itemNo: 2, order: 2, itemName: "20's" },
          { id: "3", itemNo: 3, order: 3, itemName: "30's" },
          { id: "4", itemNo: 4, order: 4, itemName: "40's" },
          { id: "5", itemNo: 5, order: 5, itemName: "50's" },
          { id: "6", itemNo: 6, order: 6, itemName: "60's and over" }
        ]
      },
      zh: {
        attrName: "年龄",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "青少年" },
          { id: "2", itemNo: 2, order: 2, itemName: "20多岁" },
          { id: "3", itemNo: 3, order: 3, itemName: "30多岁" },
          { id: "4", itemNo: 4, order: 4, itemName: "40多岁" },
          { id: "5", itemNo: 5, order: 5, itemName: "50多岁" },
          { id: "6", itemNo: 6, order: 6, itemName: "60多岁及以上" }
        ]
      },
      vi: {
        attrName: "Tuổi",
        attrItems: [
          { id: "1", itemNo: 1, order: 1, itemName: "Thanh thiếu niên" },
          { id: "2", itemNo: 2, order: 2, itemName: "Hai mươi" },
          { id: "3", itemNo: 3, order: 3, itemName: "Ba mươi" },
          { id: "4", itemNo: 4, order: 4, itemName: "Bốn mươi" },
          { id: "5", itemNo: 5, order: 5, itemName: "Năm mươi" },
          { id: "6", itemNo: 6, order: 6, itemName: "Trên 60 tuổi" }
        ]
      }
    }
  },
  {
    id: "new-4",
    attrNo: 4,
    order: 4,
    presetFlg: true,
    locale: {
      ja: {
        attrName: "役職",
        attrItems: [
          { id: "1", itemNo: 1, order: 2, itemName: "主任" },
          { id: "2", itemNo: 2, order: 3, itemName: "係長" },
          { id: "3", itemNo: 3, order: 4, itemName: "課長" },
          { id: "4", itemNo: 4, order: 5, itemName: "部長" },
          { id: "5", itemNo: 5, order: 6, itemName: "役員" },
          { id: "6", itemNo: 6, order: 1, itemName: "一般社員" }
        ]
      },
      en: {
        attrName: "Position",
        attrItems: [
          { id: "1", itemNo: 1, order: 2, itemName: "Boss" },
          { id: "2", itemNo: 2, order: 3, itemName: "Assistant manager" },
          { id: "3", itemNo: 3, order: 4, itemName: "Manager" },
          { id: "4", itemNo: 4, order: 5, itemName: "General manager" },
          { id: "5", itemNo: 5, order: 6, itemName: "Officer" },
          { id: "6", itemNo: 6, order: 1, itemName: "Employee" }
        ]
      },
      zh: {
        attrName: "岗位",
        attrItems: [
          { id: "1", itemNo: 1, order: 2, itemName: "首席" },
          { id: "2", itemNo: 2, order: 3, itemName: "助理经理" },
          { id: "3", itemNo: 3, order: 4, itemName: "部门经理" },
          { id: "4", itemNo: 4, order: 5, itemName: "部门" },
          { id: "5", itemNo: 5, order: 6, itemName: "官" },
          { id: "6", itemNo: 6, order: 1, itemName: "员工" }
        ]
      },
      vi: {
        attrName: "Vị trí",
        attrItems: [
          { id: "1", itemNo: 1, order: 2, itemName: "Boss" },
          { id: "2", itemNo: 2, order: 3, itemName: "Trợ lý quản lý" },
          { id: "3", itemNo: 3, order: 4, itemName: "Quản lý nhóm" },
          { id: "4", itemNo: 4, order: 5, itemName: "Quản lý" },
          { id: "5", itemNo: 5, order: 6, itemName: "Cán bộ" },
          { id: "6", itemNo: 6, order: 1, itemName: "Nhân viên" }
        ]
      }
    }
  }
];
const Attrs = () => {
  const valueSortedAttrs = ATTRS.map(attr => {
    ["ja", "en", "zh", "vi"].forEach(locale => {
      attr.locale[locale].attrItems = _.sortBy(
        attr.locale[locale].attrItems,
        item => item.order
      );
    });
    return attr;
  });
  return _.sortBy(valueSortedAttrs, attr => attr.order);
};
export default Attrs;



// WEBPACK FOOTER //
// ./src/assets/data/AttributeData.js